import { TableFormat } from 'roosterjs-editor-types';
import styled from 'styled-components';
import { StackPanel } from '../../../../../stack-panel';

export const FullWidthStackPanel = styled(StackPanel)`
    width: 100%;
`;

export const PREDEFINED_TABLE_STYLES = new Map<string, TableFormat>();
const TRANSPARENT_COLOR = 'rgba(255, 255, 255, 0)';

PREDEFINED_TABLE_STYLES.set('default', {
    bgColorEven: '#FFF',
    bgColorOdd: '#FFF',
    bottomBorderColor: 'rgb(171, 171, 171)',
    topBorderColor: 'rgb(171, 171, 171)',
    verticalBorderColor: 'rgb(171, 171, 171)'
});

PREDEFINED_TABLE_STYLES.set('grid', {
    bgColorEven: 'rgb(216, 216, 216)',
    bgColorOdd: '#FFF',
    bottomBorderColor: 'rgb(171, 171, 171)',
    topBorderColor: 'rgb(171, 171, 171)',
    verticalBorderColor: 'rgb(171, 171, 171)'
});

PREDEFINED_TABLE_STYLES.set('light-lines', {
    bgColorEven: TRANSPARENT_COLOR,
    bgColorOdd: TRANSPARENT_COLOR,
    bottomBorderColor: 'rgb(146, 192, 224)',
    topBorderColor: TRANSPARENT_COLOR,
    verticalBorderColor: TRANSPARENT_COLOR
});

PREDEFINED_TABLE_STYLES.set('two-tones', {
    bgColorEven: 'rgb(146, 192, 224)',
    bgColorOdd: TRANSPARENT_COLOR,
    bottomBorderColor: TRANSPARENT_COLOR,
    topBorderColor: TRANSPARENT_COLOR,
    verticalBorderColor: TRANSPARENT_COLOR
});

PREDEFINED_TABLE_STYLES.set('light-bands', {
    bgColorEven: 'rgb(216, 216, 216)',
    bgColorOdd: TRANSPARENT_COLOR,
    bottomBorderColor: TRANSPARENT_COLOR,
    topBorderColor: TRANSPARENT_COLOR,
    verticalBorderColor: TRANSPARENT_COLOR
});

PREDEFINED_TABLE_STYLES.set('none', {
    bgColorEven: TRANSPARENT_COLOR,
    bgColorOdd: TRANSPARENT_COLOR,
    bottomBorderColor: TRANSPARENT_COLOR,
    topBorderColor: TRANSPARENT_COLOR,
    verticalBorderColor: TRANSPARENT_COLOR
});
